<kendo-dialog [width]="dialogWidth" (close)="cancelled.emit()">
  <kendo-dialog-titlebar>
    <p class="subtitle-1">
      {{ 'outlook.appointment.recurrence.repeat' | translate }}
    </p>
  </kendo-dialog-titlebar>

  <form class="flex flex-col gap-4 text-caption" [formGroup]="form.group">
    <div class="flex gap-3">
      <kendo-formfield class="flex-1">
        <kendo-label
          [for]="repeats"
          [text]="'outlook.appointment.recurrence.repeats' | translate"
        ></kendo-label>
        <kendo-dropdownlist
          #repeats
          [data]="repeatOptions"
          textField="name"
          valueField="id"
          fillMode="solid"
          [valuePrimitive]="true"
          formControlName="repeat"
          (valueChange)="onRepeatChange($event)"
        ></kendo-dropdownlist>
      </kendo-formfield>
      @if (canSetInterval()) {
        <kendo-formfield class="w-24">
          <kendo-label
            [for]="interval"
            [text]="'outlook.appointment.recurrence.interval' | translate"
          ></kendo-label>
          <kendo-numerictextbox
            #interval
            formControlName="interval"
            format="#"
            [decimals]="0"
            [min]="minInterval"
            [max]="maxInterval"
            [autoCorrect]="true"
            (valueChange)="onRecurrenceFieldChange()"
          ></kendo-numerictextbox>
        </kendo-formfield>
      }
    </div>

    @if (canSkipWeekends()) {
      <kendo-formfield class="flex">
        <input
          id="skipWeekends"
          class="order-first"
          kendoCheckBox
          type="checkbox"
          formControlName="skipWeekends"
          (change)="onRecurrenceFieldChange()"
        />
        <label for="skipWeekends" class="ml-1 order-last k-checkbox-label">
          {{ 'outlook.appointment.recurrence.skipWeekends' | translate }}
        </label>
      </kendo-formfield>
    }

    <kendo-formfield>
      <kendo-label
        [for]="startsOn"
        [text]="'outlook.appointment.recurrence.startsOn' | translate"
      ></kendo-label>
      <kendo-datepicker
        #startsOn
        [format]="dateFormat"
        formControlName="startsOn"
        [navigation]="false"
        calendarType="classic"
        (valueChange)="onStartsOnChange()"
      ></kendo-datepicker>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label
        [for]="endsOn"
        [text]="'outlook.appointment.recurrence.endsOn' | translate"
      ></kendo-label>
      <kendo-datepicker
        #endsOn
        [format]="dateFormat"
        formControlName="endsOn"
        [min]="endsOnMin()"
        [max]="endsOnMax()"
        [navigation]="false"
        calendarType="classic"
      ></kendo-datepicker>
      <kendo-formerror>
        @if (form.controls.endsOn.hasError('noOccurrences')) {
          {{ 'outlook.appointment.recurrence.noOccurrences' | translate }}
        } @else if (form.controls.endsOn.hasError('tooManyOccurrences')) {
          {{
            'outlook.appointment.recurrence.tooManyOccurrences'
              | translate: { max: maxOccurrences }
          }}
        } @else if (form.controls.endsOn.hasError('recurrenceRange')) {
          {{
            'outlook.appointment.recurrence.rangeExceeded'
              | translate: { months: maxRangeMonths }
          }}
        } @else {
          {{ 'outlook.forms.requiredField' | translate }}
        }
      </kendo-formerror>
    </kendo-formfield>

    <div>
      <p class="caption text-neutral-60 mb-1">
        {{ 'outlook.appointment.recurrence.summary' | translate }}
      </p>
      <p class="text-body text-neutral-90">{{ summary() }}</p>
      @if (truncationNote(); as note) {
        <p class="caption text-neutral-60 mt-1">{{ note }}</p>
      }
    </div>
  </form>

  <kendo-dialog-actions layout="end">
    <button
      kendoButton
      id="outlook-appointment-ui-repeatDialog-cancel"
      class="uppercase"
      themeColor="primary"
      fillMode="flat"
      (click)="cancelled.emit()"
    >
      {{ 'outlook.buttons.cancel' | translate }}
    </button>
    <button
      kendoButton
      id="outlook-appointment-ui-repeatDialog-save"
      class="uppercase"
      themeColor="primary"
      [disabled]="!form.valid"
      (click)="save()"
    >
      {{ 'outlook.buttons.save' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
